import { Toast } from '@core/models/toast/toast';

export interface IToastState {
    toast: Toast;
}

export function initialToastState():IToastState {
    return {
        toast: null
    };  
};